import React from "react"

import { AppAntSwitch } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsSameInsurance() {

	const {
		dataInfo, setDataInfo
	} = useAlertsDataInfo(alertsDrawerData.peek().sameInsurance)

	return <AppAntSwitch
		checked={dataInfo.value}
		onChange={e => setDataInfo(e.target.checked, 'sameInsurance')}
		trueText="Same insurance"
	/>
}